<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CgtNCO/tc-custom/9781488012983.jpg?1728724861185" alt="This image is the cover for the book Manhunt on Mystic Mesa, The Ranger Brigade: Family Secrets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Manhunt on Mystic Mesa, The Ranger Brigade: Family Secrets
      </h1>
      <p class="bookDescription body article font2">
        <b>A rule-following ranger finds himself on the hunt for a killer—and falling for a woman who should be off-limits . . .</b><br/><br/>On the hunt for a serial killer, ranger Ryan Spencer can’t afford any distraction. But Jana Lassiter, sister to one of the missing women, won’t let Ryan investigate Mystic Mesa alone. Even though the seasoned officer has always gone by the book, something tells him it wouldn’t be so bad to break a few rules for Jana.<br/><br/>When Jana’s life is suddenly jeopardized, the lawman is forced to face his darkest fears. He’s allowed desire to overshadow duty. Now he has to rein in his emotions to save Jana from becoming the next victim. Because losing this woman he’s inexplicably fallen for will destroy this warrior forever . . .<br/><br/><b>Praise for the author</b><br/><br/>“Superior . . . captivating.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cindi Myers
      </h2>
      
      <p class="authorDescription body article"><B>Cindi Myers</B> became one of the most popular people in eighth grade when she and her best friend wrote a torrid historical romance and passed the manuscript around among friends. Fame was short-lived, alas; the English teacher confiscated the manuscript. Since then, Cindi has written more than 50 published novels. Her historical and contemporary romances and women&rsquo;s fiction have garnered praise from reviewers and readers alike.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20632f3e